<div class="tab-box" *ngIf="!basica">
  <div class="title-ind">
    <h1 class="title-tab">Instalaciones</h1>
    <div class="stackedBarTitle">
      <canvas #stackedCanvasTitleInstalacion></canvas>
    </div>
  </div>
    <div class="acciones-tabla">
      <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla>
      <div>
        <app-nueva-entidad (click)="openDialog()"></app-nueva-entidad>
        <button class="boton-descarga" (click)="exportAsExcel()">
          <img class="boton-descarga__icon" src="../../../../assets/descargar.svg" />
          Descargar
        </button>
      </div>
    </div>
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">   
       <!--  <ng-container matColumnDef="id">
          <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let instalacion" (click)="openDetails(instalacion.id)">{{ instalacion.id }}</td>
        </ng-container> -->
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</th>
          <td mat-cell *matCellDef="let instalacion" (click)="openDetails(instalacion.id)">{{ instalacion.nombre }}</td>
        </ng-container>
        <ng-container matColumnDef="direccion.nombre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>DIRECCIÓN</th>
          <td mat-cell *matCellDef="let instalacion" (click)="openDetails(instalacion.id)">
            <div *ngIf="instalacion.direccion; else elseBlock">
              {{ instalacion.direccion?.tipoVia }} {{instalacion.direccion?.nombre}} {{instalacion.direccion?.numero}} {{instalacion.direccion?.ccaa}}
            </div>
            <ng-template #elseBlock>-</ng-template>
          </td>  
        </ng-container>
          <ng-container matColumnDef="zona">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ZONAS</th>
            <td mat-cell *matCellDef="let instalacion" (click)="openDetails(instalacion.id)">
              <div *ngIf="instalacion.zonas; else elseBlock">
                <div *ngFor="let zona of instalacion?.zonas">
                  {{ zona?.nombre }}
                </div>
              </div>
              <ng-template #elseBlock>-</ng-template>
            </td>
          </ng-container>
        <ng-container matColumnDef="agrupacion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>CAMPO (GRUPO)</th>
          <td mat-cell *matCellDef="let instalacion" (click)="openDetails(instalacion.id)">
            <div *ngIf="instalacion.campos; else elseBlock">
              <div *ngFor="let campo of instalacion?.campos">
               {{ campo?.nombre }} ({{ campo?.agrupacion?.nombre }})
              </div>
            </div>
            <ng-template #elseBlock>-</ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="indicadores">
          <th mat-header-cell *matHeaderCellDef>INDICADORES</th>
          <td mat-cell *matCellDef="let instalacion">
            <div class="stackedBar">
              <canvas #stackedCanvasInstalacion id="{{instalacion.id}}"></canvas>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
          <td mat-cell *matCellDef="let instalacion">
            <!-- <img
              class="tabla-editar"
              src="../../../../../assets/lapiz.png"
              (click)="updateInstalacionById(instalacion.id)"
            /> -->
            <img
              class="tabla-borrar"
              src="../../../../../assets/trash.png"
              (click)="handleClick(instalacion.id)"
            />
          </td>
        </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10,15,20]" (click)="getInstalacionesByCliente()"></mat-paginator>
  
  </div>
